import { useState } from "react";
import { usePassAuth } from "../../context/PasswordAuthContext";
import { useNavigate } from "react-router-dom";

import { useEffect } from "react";

const ForgotPassword = () => {
  const { forgotPassword, loading, checkResetStatus } = usePassAuth();
  const [startChecking, setStartChecking] = useState(false);

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  //   useEffect(() => {
  //     if (!startChecking) return;

  //     const interval = setInterval(async () => {
  //       try {
  //         const res = await checkResetStatus(email);
  //         console.log("resdata", res);

  //         if (res.allowReset) {
  //           clearInterval(interval);

  //           navigate(`/reset-password?email=${email}&account=unlock`);
  //         }
  //       } catch (err) {
  //         console.log("status check error", err);
  //       }
  //     }, 2000);

  //     return () => clearInterval(interval);
  //   }, [startChecking, email]);
  // useEffect(() => {
  //   if (!startChecking) return;

  //   const interval = setInterval(async () => {
  //     try {
  //       const res = await checkResetStatus(email);
  //       console.log("resdata", res);

  //       if (res.verified === true) {
  //         clearInterval(interval);
  //         navigate(`/reset-password?email=${email}&account=unlock`);
  //       }
  //     } catch (err) {
  //       console.log("status check error", err);
  //     }
  //   }, 2000);

  //   return () => clearInterval(interval);
  // }, [startChecking, email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await forgotPassword(email);
      console.log("res", res);

      if (res.allowReset) {
        navigate(`/reset-password?email=${res.email}&account=direct`);
        return;
      }

      setMessage(res.message);
      setStartChecking(true);
    } catch (err) {
      setMessage(err?.response?.data?.message || "Error sending reset email");
    }
  };

  return (
    // <div>
    //   <h2>Forgot Password</h2>

    //   <form onSubmit={handleSubmit}>
    //     <input
    //       type="email"
    //       placeholder="Enter registered email"
    //       value={email}
    //       onChange={(e) => setEmail(e.target.value)}
    //     />

    //     <button disabled={loading}>
    //       {loading ? "Sending..." : "Send Reset Link"}
    //     </button>
    //   </form>

    //   {message && <p>{message}</p>}
    // </div>
    <div className="reg-page-wrapper">
      <h2 className="reg-page-title">Forgot Password</h2>

      <form className="reg-form" onSubmit={handleSubmit}>
        {/* ================= EMAIL ================= */}

        <input
          className="reg-input"
          type="email"
          placeholder="Enter registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* ================= MESSAGE ================= */}

        {message && (
          <p className="reg-error" style={{ textAlign: "center" }}>
            {message}
          </p>
        )}

        {/* ================= BUTTON ================= */}

        <button className="reg-submit-btn" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>

      {/* ================= BACK TO LOGIN ================= */}

      <p style={{ textAlign: "center", marginTop: "16px" }}>
        Remember your password?{" "}
        <span
          style={{ fontWeight: "500", cursor: "pointer", color: "#007bff" }}
          onClick={() => navigate("/login")}
        >
          Login
        </span>
      </p>
    </div>
  );
};

export default ForgotPassword;
